import { FETCH_ROUTE_FAILED, FETCH_ROUTE_SUCCESS, FETCH_ROUTE_PROGRESS, OPEN_PARKING_LOT_POPUP, CLOSE_PARKING_LOT_POPUP, SET_DATE_TIME, SWAP_LOCATIONS, ALTERNATE_DESTINATION, ALTERNATE_START, SET_SIDEBAR_VISIBILITY } from './types';

const key = "e-Tuzu0QOkZ12AgFa_8XXmUYCbl5sxM0b20S1gx8918";
const H = window.H;
const platform = new H.service.Platform({
    apikey: key
});
const service = platform.getSearchService();

/**
 *  fetches up to 6 routes from start to destination, dispatches:
 *      type:               FETCH_ROUTE (relevant for reducer)
 *      payload:            the entire json answer of the query
 *      times:              duration of all routes
 *      departureTimes:     departure times of each route
 *      arrivalTimes:       time of arrival of each route
 *      parkingTimes:       time of arrival at each route's parking lot
 *      parkingLotNames:    names of each route's parking lot
 */
export const fetchRoute = (start, destination, time) => dispatch => {
    if (start === undefined) {
        throw 'Start has not been selected yet';
    } else if (destination === undefined) {
        throw 'Destination has not been selected yet';
    }

    dispatch({ type: FETCH_ROUTE_PROGRESS });
    let departureTime = '';

    if (time != null) {
        departureTime = '&departureTime=' + time;
    }

    fetch('https://intermodal.router.hereapi.com/v8/routes'
        + '?origin=' + start.lat + ',' + start.lng
        + '&destination=' + destination.lat + ',' + destination.lng
        + departureTime
        + '&vehicle[enable]=routeHead'
        + '&vehicle[modes]=car'
        + '&transit[enable]=routeTail'
        + '&rented[enable]=`'
        + '&taxi[enable]=`'
        + '&via=place:parkingLot'
        + '&strategy=parkLate'
        + '&alternatives=6'
        + '&return=travelSummary,polyline,fares,intermediate'
        + '&apiKey=' + key)
        .then(response => response.json())
        .then(data => dispatch({
            type: FETCH_ROUTE_SUCCESS,
            payload: data,
            times: calculateRouteDuration(data),
            departureTimes: getDepartureTimes(data),
            parkingTimes: getParkingTimes(data),
            arrivalTimes: getArrivalTimes(data),
            parkingLotNames: getParkingLotNames(data),
            parkingLotLocations: getParkingLotLocations(data),
            parkingPrices: getParkingPrices(data),
            parkingLotAddresses: getParkingLotAddresses(data),
        }))
        .catch((e) => {
            dispatch({ type: FETCH_ROUTE_FAILED });
        });
}

const calculateRouteDuration = data => {
    let output = [];

    data.routes.forEach(route => {
        const sections = route.sections;
        const departure = new Date(sections[0].departure.time);
        const arrival = new Date(sections[sections.length - 1].arrival.time);
        output.push(convertMilliseconds(arrival - departure));
    });

    return output;
}

const convertMilliseconds = ms => {
    const minutes = Math.round(ms / 1000 / 60);

    if (minutes < 60) {
        return minutes + 'min';
    } else {
        const hours = Math.floor(minutes / 60);
        const min = minutes - parseInt(hours) * 60;
        return hours + 'h ' + min + 'min';
    }
}

//  extract departure times
const getDepartureTimes = data => {
    let output = [];

    data.routes.forEach(route => {
        output.push(clean(route.sections[0].departure.time));
    });

    return output;
}

//  extract parking times
const getParkingTimes = data => {
    let output = [];

    data.routes.forEach(route => {
        output.push(clean(route.sections[0].arrival.time));
    });

    return output;
}

//  extract arrival times
const getArrivalTimes = data => {
    let output = [];
    let length = 0;

    data.routes.forEach(route => {
        length = route.sections.length - 1;
        output.push(clean(route.sections[length].arrival.time));
    });

    return output;
}

//  extract HH:mm out of the standard time-data string
const clean = time => {
    return time.substr(11, 5);
}

//  extract parking lot names
const getParkingLotNames = data => {
    let output = [];

    data.routes.forEach(route => {
        output.push(route.sections[0].arrival.place.name);
    });

    return output;
}

const getParkingLotLocations = data => {
    let output = [];

    data.routes.forEach(route => {
        output.push(route.sections[0].arrival.place.location);
    });

    return output;
}

const getParkingLotAddresses = data => {
    let output = [];

    data.routes.forEach(route => {
        let address = [];
        const geoLocation = route.sections[0].arrival.place.location.lat + ',' + route.sections[0].arrival.place.location.lng;

        service.reverseGeocode({
            at: geoLocation
        }, (result) => {
            result.items.forEach(item => {
                address.push(item.address.label)
            });
            output.push(address);
        });
    }, alert);

    return output;
}

const getParkingPrices = data => {
    let output = [];
    data.routes.forEach(route => {
        try {
            let price = route.sections[0].fares[0].price.value;

            if (price === '0' || price === '0.0' || price === '0.00') {
                output.push('');
            } else {
                output.push(price + ' €');
            }
        } catch {
            output.push('');
        }
    });

    console.log(output);
    return output;
}

/**
 * sets the location, which is either start or destination, dispatches:
 *  type:       depending on start or destination
 *  payload:    corelating value to be set
 */
export const setLocation = (location, type) => dispatch => {
    dispatch({
        type: type,
        payload: location
    });
}

/**
 * queries @param query with Munich as a point of reference; result is limited to 1.
 * Result will be set to either start or destination, depending on type; dispatches:
 *  type:       depending on start or destination
 *  payload:    query result
 */
export const fetchLocation = (query, type) => dispatch => {
    service.autosuggest({
        q: query,
        at: '48.1371436,11.5753989',
        limit: 1,
    }, (result) =>
        dispatch({
            type: type,
            payload: result.items
        })
    );
};

/**
 * queries @param query with Munich as a point of reference; result is limited to 5.
 * Result will be set to either start or destination, depending on type; dispatches:
 *  type:       depending on start or destination
 *  payload:    query result
 * 
 * TODO:    fetchLocation and fetchSuggeestions function similarly and should probably
 *          be summarized
 */
export const fetchSuggestions = (query, type) => dispatch => {
    if (query === '') {
        return [];
    }
    service.autosuggest({
        q: query,
        at: '48.1371436,11.5753989',
        limit: 5,
    }, (result) => {
        let output = [];
        result.items.forEach(item => {
            //  Dirty implementation; trying to avoid API answers without a location
            //  Extract necessary information and put into SemanticUI-readable form
            //  First try-catch: establishments that can be categorized
            try {
                let tmp = {
                    title: item.address.label,
                    description: item.categories[0].name,
                    content: item.title,
                    coordinates: item.position
                }

                output.push(tmp);
            } catch {
                //  Second try-catch: streets, cities, regions etc
                try {
                    let tmp = {
                        title: item.address.label,
                        content: item.title,
                        coordinates: item.position
                    }

                    output.push(tmp);
                } catch { }
            }

        });
        dispatch({
            type: type,
            payload: output
        });
    });
};

export const openParkingLotPopup = () => dispatch => dispatch({
    type: OPEN_PARKING_LOT_POPUP
});

export const closeParkingLotPopup = () => dispatch => dispatch({
    type: CLOSE_PARKING_LOT_POPUP
});

/**
 * set selected route; relevant for dropdowns in the sidebar (RoutingMenu), dispatches:
 *  index:  index of the clicked dropdown
 */
export const selectRoute = (index, type) => dispatch => dispatch({
    type: type,
    index: index
});

export const finishSearch = (suggestions, type) => dispatch => dispatch({
    type: type,
    payload: suggestions
});

export const cleanQuery = (type) => dispatch => dispatch({
    type: type
});

export const updateSelection = (selected, type) => dispatch => dispatch({
    type: type,
    selected: selected
});

export const startLocationSearch = (query, type) => dispatch => dispatch({
    type: type,
    query: query
});

export const setDateTime = dateTime => dispatch => dispatch({
    type: SET_DATE_TIME,
    dateTime: dateTime
});

export const swapLocations = (start, destination) => dispatch => {
    console.log(start, destination);
    if(start === '' && destination !== '') {
        dispatch({
            type: ALTERNATE_DESTINATION,
            newStart: destination,
        });
    } else if (destination === '' && start !== '') {
        dispatch({
            type: ALTERNATE_START,
            newDestination: start,
        })
    } else if (start !== '' && destination !== '') {
        dispatch({
            type: SWAP_LOCATIONS,
            newStart: destination,
            newDestination: start,
        });
    }
}

export const setSidebarVisibility = () => dispatch => dispatch({
    type: SET_SIDEBAR_VISIBILITY
});